export const RECENT_SEARCH_TOKEN = 'recentHistory'

export const PRIVACY_POLICY_LINK = 'https://www.munichre.com/hsb/en/general/legal/privacy-statement.html'
export const TERMS_OF_USE_LINK = 'https://www.munichre.com/hsb/en/general/legal/terms-of-use.html'

export const INSIGHTS_URL = import.meta.env.VITE_INSIGHTS_URL ?? 'https://meshifyinsightsdev.co/'
export const PROTECT_LITE_URL = import.meta.env.VITE_PROTECT_LITE_URL ?? 'https://dev.meshifyprotect.com/'
export const BRANCH_URL = 'https://meshifyprotect.app.link'
export const BRANCH_ENV = import.meta.env.VITE_BRANCH_ENV ?? '/dev'
export const GLOBAL_API = import.meta.env.VITE_GLOBAL_API ?? 'https://global.meshbot.co'
export const { OID_AUTHORITY, OID_CLIENT_ID } = import.meta.env

export const GOOGLE_PLACES_API_KEY = import.meta.env.VITE_GOOGLE_PLACES_API_KEY

export const RELEASE_NOTES_TAG = 'app:central'

export const LOCAL_STORAGE_KEYS = {
  LOGGED_OUT: 'logged-out',
}

export const LOCALHOST_HOST = `https://carbon.meshbot.co`
